import React from 'react';
import Table, { TableColumn } from '../../../../../components/Table';
import { IReprocessResult } from '../../types';
import {
  Card,
  CardTitle,
  SummaryRow,
  SummaryItem,
  Warning,
} from './styles';

interface SyncResultProps {
  result: IReprocessResult;
}

const SyncResult: React.FC<SyncResultProps> = ({ result }) => {
  // Defensivo: em respostas parciais/inesperadas do backend, failures/warnings
  // podem vir undefined. Sem isso, .map/.length lançam TypeError e a tela
  // (sem Error Boundary) fica branca.
  const failures = result.failures ?? [];
  const warnings = result.warnings ?? [];

  const failureData = failures.map((failure, index) => ({
    key: index,
    uuid: failure.uuid ?? '-',
    merchant: failure.merchant ?? '-',
    reason: failure.reason,
  }));

  return (
    <Card>
      <CardTitle>Resultado do reprocessamento</CardTitle>

      <SummaryRow>
        <SummaryItem>
          <span>Transações encontradas</span>
          <span>{result.totalFound}</span>
        </SummaryItem>
        <SummaryItem>
          <span>Sincronizadas com sucesso</span>
          <span>{result.sent}</span>
        </SummaryItem>
        <SummaryItem>
          <span>Falhas</span>
          <span>{failures.length}</span>
        </SummaryItem>
      </SummaryRow>

      {warnings.length > 0 && (
        <div>
          {warnings.map((warning, index) => (
            <Warning key={`warning-${index}`}>{warning}</Warning>
          ))}
        </div>
      )}

      {failures.length > 0 && (
        <Table dataSource={failureData} pagination={{ pageSize: 10 }}>
          <TableColumn title="UUID" dataIndex="uuid" key="uuid" />
          <TableColumn title="Codigo do lojista" dataIndex="merchant" key="merchant" />
          <TableColumn title="Motivo" dataIndex="reason" key="reason" />
        </Table>
      )}
    </Card>
  );
};

export default SyncResult;
